// Keep existing saved links working without retaining the old Site Settings wrapper.
export const adminLocation = (params) => {
  let section = params.get('section') || 'analytics', view = params.get('view');
  if (section === 'games') section = 'originals';
  if (section === 'site') {
    const tab = params.get('tab') || 'settings';
    section = { settings: 'originals', users: 'users', tipping: 'tipping', alerts: 'alerts', construction: 'construction', audit: 'audit', bets: 'audit' }[tab] || 'originals';
    if (tab === 'bets') view = 'bets';
  }
  if (section === 'tipping' && view === 'logs') { section = 'audit'; view = 'tips'; }
  if (section === 'tipping') section = 'credits';
  return { section, view };
};